import myHeader from "../../components/header.vue"
import {
  getUserCourseStudyDetailFromSingleCourse,
  saveUserStudyTime,
  getEnterpriseWebsite
} from "@/apiCloud/coursePlayByPrivate"

import {
  eUrl
} from "@/api/baseURL.js";
let that
// let oldTokenId=localStorage.getItem("tokenId")
export default {
  // components: {
  //   myHeader
  // },
  data() {
    return {
      select: 'hh',
      player: null,
      playTime: 0,
      show: true,
      liSelected: '100',
      playHeight: '400',

      remove: false,
      current: -1,
      vid: '',
      ccId: '',
      start: 0,
      courseOver: '',

      packagebagId: '',
      courseId: '',
      empStudyId: '',
      courseName: '',
      intervalid1: null,
      interval: null,
      autoPlay: true,
      baseInfoCatalogList: [],
      empHeadportrait: '',
      coursePic: '',
      resouceHours: 0,
      isSave: false,
      playData: {},
      oldTokenId: '',
      oldPlayTime: 0,
      playObj: {},
      abnormalOldPlayTime: 0,
      regId: "",
      // 看课拍照参数
      courseConfig: {
        camera: false,
        completeRateFlag: 90,
        canDrop: "on"
      },
      singleCourseId:null
    }
  },
  beforeCreated() {},
  created() {
    this.oldTokenId = localStorage.getItem("oldTokenId");
    this.playData = JSON.parse(localStorage.getItem("playData")); //课程详情页面进入播放页面存入的播放所需参数
    this.packagebagId = this.playData.packagebagId;
    this.regId = this.playData.regId;
    this.courseId = this.playData.courseId;
    this.empHeadportrait = localStorage.getItem("empHeadportrait"); //获取学员头像
    this.getCourseBaseInfoCatalog();
    that = this
  },
  mounted() {
    this.getScreenHeight()
  },
  beforeDestroy() {
    clearInterval(that.intervalid1);
    that.intervalid1 = null;
    clearInterval(that.interval);
    that.interval = null;
    /**保利威替换 start */
    // that.player.destroy();
    /**保利威替换 end */

    // window.j2s_stopVideo()
  },

  methods: {
    //获取目录和详情,调取播放器
    getCourseBaseInfoCatalog() {
      let data = {
        courseId: this.courseId
      };
      getUserCourseStudyDetailFromSingleCourse(data).then(res => {
        if (res.code == 200) {
          this.singleCourseId = res.data.singleCourseId
          this.baseInfoCatalogList = res.data.courseCatalogList
          this.coursePic = res.data.coursePic
          this.courseName = res.data.courseName
          if (this.playData.vid) {
            /**保利威替换 start */
            // this.vid = this.playData.vid;
            /**保利威替换 end */
            /**播放器 start */
            let $vid =  this.playData.vid
            /**播放器 end */
            this.liSelected = this.playData.liSelected
            this.start = this.playData.courseDelayTime
            this.ccId = this.playData.ccId
            this.resouceHours = this.playData.resouceHours
            // this.autoPlay = true
            /**播放器 start */
            this.autoPlay = false;
            /**播放器 end */
            this.playerStart($vid); //播放器 此处加了一个入参
          } else {
            /**保利威替换 start */
            // this.vid = this.baseInfoCatalogList[0].cousecate[0].vid;
            /**保利威替换 end */
            /**播放器 start */
            let $vid =  this.baseInfoCatalogList[0].cousecate[0].vid;
            /**播放器 end */
            this.ccId = this.baseInfoCatalogList[0].ccId;
            // this.autoPlay = false
            this.playerStart()
            $("#player").css("display", "none")
            $("#buylink").css("display", "none")
            $("#startScreen").css("display", "block")
          }
        }
      })
    },
    //播放器
    playerStart($vid) { //播放器 此处加了一个入参
      console.log($vid)
      let _this = this
      // clearInterval(_this.timeOut);
      console.log('playerStart_wx')
      this.isSave = false
      // this.player = polyvObject('#player').videoPlayer({
      //   'width': 'auto',
      //   'height': this.playHeight,
      //   'list_id': 'id',
      //   'forceH5': true,
      //   'speed': false,
      //   'ignoreIE': true,
      //   'ban_seek_by_limit_time': 'on',
      //   "autoplay": this.autoPlay,
      //   "watchStartTime": this.start,
      //   'flashvars': {
      //     'allowscriptaccess': "always",
      //     'allowNetworking': "all",
      //     "setScreen": "16_9",
      //   },
      //   'vid': this.vid
      // })
      // this.player = polyvPlayer({
      //   wrap: '#player',
      //   'width': 'auto',
      //   'height': _this.playHeight,
      //   autoplay: false,
      //   vid: _this.vid,
      //   'ban_seek': _this.courseConfig.canDrop,
      //   'speed': false,
      //   "watchStartTime": _this.start || 0,
      //   // playsafe: 'c7cabb17-579c-42df-9e11-afc71ac6120b-c12678',
      //   // ts:'1649934545000',
      //   // sign:'de2234b62946998946275e2524696d59',
      //   // params:{'param2':'tony','param1':'1000',},
      // });
      /**播放器start */
      //调整到最后改变vid，播放器自动播放视频
      //在此之前，startTime（播放开始时间），
      //  dragEnable（是否可拖拽）先改变好
      if($vid){
        this.vid = $vid 
      }
      /**播放器end */

      console.log("打印播放器生成时各个属性", _this.player)
      if (_this.start > 0) {
        _this.oldPlayTime = _this.start
      } else {
        _this.oldPlayTime = 0
      }
      window.s2j_onVideoPlay = function () { //视频开始播放
        // console.log("视频开始播放")
        _this.intervalid1 = setInterval(() => {
          if (_this.courseOver == 1) {
            _this.saveUserCourseStudingData(1)
          } else {
            _this.saveUserCourseStudingData(0)
          }
        }, 120000);
        _this.getCourseCatalog();
        _this.interval = setInterval(_this.render, 1000)
      };
      window.s2j_onVideoPause = function () { //视频暂停播放
        clearInterval(_this.intervalid1);
        clearInterval(_this.interval)
      };
      window.s2j_onPlayOver = function () { //视频播放完成
        clearInterval(_this.intervalid1);
        clearInterval(_this.interval);
        _this.autoPlay = false;
        _this.saveUserCourseStudingData(1);
        $("#player").css("display", "none");
        $("#buylink").css("display", "block");
        $("#startScreen").css("display", "none");
        let parent = _this.liSelected.split("-")[0];
        let child = _this.liSelected.split("-")[1];
        _this.baseInfoCatalogList.map((item, index) => { //播放完成之后立马显示已经完成的图标
          if (index == parent) {
            let cousecate = item.cousecate;
            cousecate.map((temp, sub) => {
              if (sub == child) {
                temp.courseOver = 1
              }
            })
          }
        });
        setTimeout(function () {
          _this.getCourseCatalog()
        }, 500)
      }
    },
    ycyOnPlay(){
      console.log("ycyOnPlay")
      if(window.s2j_onVideoPlay){
        window.s2j_onVideoPlay()
      }
    },
    ycyOnPause(){
      console.log("ycyOnPause")
      if(window.s2j_onVideoPause){
        window.s2j_onVideoPause()
      }
    },
    ycyOnEnded(){
      console.log("ycyOnEnded")
      if(window.s2j_onPlayOver){
        window.s2j_onPlayOver()
      }
    },

    //保存视频时长
    saveUserCourseStudingData(isOver) {
      if (
        !localStorage.getItem("tokenId") || 
        localStorage.getItem("tokenId") == "") {
        /**保利威替换 start */
        // this.player.destroy();
        /**保利威替换 end */
        this.$alert('账号登录失效，请退出后重新登录！', '提示', {
          confirmButtonText: '确定',
          showClose: false,
          callback: action => {
            this.$router.push({
              name: 'home'
            })
            sessionStorage.setItem("$isUserLogin", false)
          }
        });
      } else if (this.oldTokenId != localStorage.getItem("tokenId")) { 
        //两个账号登陆
        /**保利威替换 start */
        // this.player.destroy();
        /**保利威替换 end */
        
        this.open()
      } else {
        let data = {
          // packagebagId: this.packagebagId, // 套餐包Id
          courseId: this.courseId, // 课程Id
          ccId: this.ccId, //视频VID
          courseDelayTime: this.playTime, //视频播放时长
          courseOver: isOver,
          singleCourseId: this.singleCourseId
        };
        let _this = this;
        saveUserStudyTime(data).then(res => {
          if (res.code == 200) {
            if (isOver == 1) {
              this.isSave = true //当保存时长成功之后，不再进行二次保存
              setTimeout(function () {
                let parent = _this.liSelected.split("-")[0]
                let child = _this.liSelected.split("-")[1]
                that.baseInfoCatalogList.map((item, index) => { //播放完成之后立马显示已经完成的图标
                  if (index == parent) {
                    let cousecate = item.cousecate
                    cousecate.map((temp, sub) => {
                      if (sub == child) {
                        temp.courseOver = 1
                      }
                    })
                  }
                })
                that.getCourseCatalog()
              }, 500)
            } else {
              setTimeout(() => {
                that.getCourseCatalog();
              }, 3000);
            }
            
          } else {
            this.$message.error(res.message);
            if (res.code == 2202) { //登陆失效
              /**保利威替换 start */
              // this.player.destroy();
              /**保利威替换 end */
              this.$alert('账号登录失效，请退出后重新登录！', '提示', {
                confirmButtonText: '确定',
                showClose: false,
                callback: action => {
                  this.$router.push({
                    name: 'home'
                  })
                  sessionStorage.setItem("$isUserLogin", false)
                }
              });
            } else if (res.code == 2203) {
              that.abnormalOldPlayTime = JSON.parse(JSON.stringify(that.oldPlayTime));
              this.$message({
                type: 'warning',
                message: res.message
              });
              that.play(that.playObj.vid, that.playObj.ccId, that.playObj.courseDelayTime, that.playObj.index, that.playObj.sub, that.playObj.courseOver, that.playObj.resouceHours);

              /**保利威视频替换 start */
              // that.player.j2s_seekVideo(that.abnormalOldPlayTime);
              /**保利威视频替换 end */

              /**播放器 start */
              that.$refs.ycyPlayer.jumpToTime(that.abnormalOldPlayTime)
              /**播放器 end */
            }
          }
        })
      }

    },
    getEnterpriseWebsite() { //根据域名获取企业id
      // var eUrl = window.location.href;
      // var eUrl = 'http://snyg.e.eceping.net';

      // var eUrl="http://www.eceping.net"
      //  var eUrl="http://hnpx.enterprise.eceping.net"
      var param = {
        entpWebsite: eUrl /*eUrl.substring(0,eUrl.indexOf(":",5))*/
      };
      getEnterpriseWebsite(param).then(res => {
        if (res.code == 200) {
          localStorage.setItem("enterpriseId", res.data.entpId)
          localStorage.setItem("entpCreditNo", res.data.entpCreditNo)
        }
      })
    },
    //获取目录和详情
    getCourseCatalog() {
      let data = {
        courseId: this.courseId,
        packagebagId: this.packagebagId
      }
      getUserCourseStudyDetailFromSingleCourse(data).then(res => {
        if (res.code == 200) {
          this.singleCourseId = res.data.singleCourseId
          this.baseInfoCatalogList = res.data.courseCatalogList
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //选中某一条视频进行播放
    play(
      vid, 
      ccId, 
      courseDelayTime,
      index, 
      sub, 
      courseOver, 
      resouceHours
      ) {
        // if(vid=='08c200b441294fb744f77899ede2e233_0'){
        //   vid="7810A3BA60546DE4753C612EB38A8D5A"
        // }
        // if(vid=='08c200b4412b9ef7eed1a17fb76ab509_0'){
        //   vid="95C0168A7E9663817E6C9CEE8B422289"
        // }
      that.playObj = {
        vid: vid,
        ccId: ccId,
        courseDelayTime: courseDelayTime,
        index: index,
        sub: sub,
        courseOver: courseOver,
        resouceHours: resouceHours
      };
      /**保利威替换 start */
      // that.player.destroy();
      /**保利威替换 end */
      this.resouceHours = resouceHours;
      $("#player").css("display", "block");
      $("#buylink").css("display", "none");
      $("#startScreen").css("display", "none");
      this.current = index;
      this.select = index + 's';
      /**保利威替换 start */
      // that.vid = vid;
      /**保利威替换 end */
      /**播放器 start */
      let $vid = vid
      /**播放器 end */
      this.ccId = ccId;
      this.start = courseDelayTime;
      this.autoPlay = true;
      this.liSelected = index + "-" + sub;
      this.courseOver = courseOver;
      this.playerStart($vid); //播放器 此处加了一个入参
    },
    //播放器的记时功能
    render() {
      if (
        /**保利威替换 start */
        // this.player != undefined &&
        // this.player.j2s_getCurrentTime != undefined
        /**保利威替换 end */
        /**播放器 start */
        this.$refs.ycyPlayer != undefined && 
        this.$refs.ycyPlayer.getCurrentTime != undefined
        /**播放器 end */
        ) {
         /**保利威替换 start */
        // this.playTime = this.player.j2s_getCurrentTime();
        /**保利威替换 end */
        /**播放器 start */
        this.playTime = this.$refs.ycyPlayer.getCurrentTime();
        if (this.oldPlayTime != 0 && this.playTime >= this.oldPlayTime + 2) {
          /*    this.player.j2s_seekVideo(this.oldPlayTime)*/
        } else if (this.oldPlayTime == 0 && this.playTime >= this.oldPlayTime + 2) {
          /*this.player.j2s_seekVideo(this.oldPlayTime++)*/
        } else {
          this.oldPlayTime = this.playTime;
          let resouceHours = this.timeToSec(this.resouceHours) - 60;
          if (this.playTime >= resouceHours) { //还剩1分钟时调用接口
            if (!this.isSave) {
              this.saveUserCourseStudingData(1)
            }
          }
        }

        let userPlayRecord = JSON.parse(localStorage.getItem("userPlayRecord"))
        let data = { //当前播放视频信息
          ccId: this.ccId,
          playTime: this.playTime,
          courseId: this.courseId,
          tokenId: localStorage.getItem("tokenId"),
          time: new Date()
        };
        if (userPlayRecord && userPlayRecord != undefined && userPlayRecord != null) { //缓存里面存在用户的播放数据
          userPlayRecord.forEach((item, i) => {
            if (item.ccId == this.ccId && item.tokenId == localStorage.getItem("tokenId")) {
              item.playTime = this.playTime;
              item.time = new Date()
            } else {
              userPlayRecord.push(data)
            }
          })
        } else {
          userPlayRecord = [];
          userPlayRecord.push(data)
        }
        localStorage.setItem("userPlayRecord", JSON.stringify(userPlayRecord))

      }
    },


    //伸缩章节
    pulling(cataLog, event) {
      var el = event.currentTarget
      let idName = "#" + cataLog
      let ispull = $(idName).attr('ispull')
      if (ispull == 'true') {
        $(idName).removeClass("show")
        $(idName).attr('ispull', 'false')
        $(el).find(".up").hide()
        $(el).find(".down").show()
      } else {
        $(idName).addClass("show")
        $(idName).attr('ispull', 'true')
        $(el).find(".down").hide()
        $(el).find(".up").show()
      }
    },
    //获取屏幕高度
    getScreenHeight() {
      var clientHeight = document.documentElement.clientHeight
      var clientWidth = document.documentElement.clientWidth
      // console.log("可视高度",clientHeight,"可视宽度",clientWidth)
      this.playHeight = (clientHeight - 60)
      // console.log(this.playHeight)
      $("#videoPlay").height(this.playHeight)
      $("#playerBox").height(this.playHeight)
      $("#player").height(this.playHeight-20)
      $("#videoList").height(this.playHeight)
      $("#videoBox").height(this.playHeight)
      $("#buylink").height(this.playHeight)
      $("#startScreen").height(this.playHeight)
    },
    //路由回退
    goBack() {
      sessionStorage.setItem("coursePlayGoBack", 1)
      this.$router.replace({
        path: "/courseDetail",
        name: "courseDetail",
        params: {
          courseId: this.courseId,
          packagebagId: this.packagebagId
        }
      })
    },

    //将时分秒转换成秒
    timeToSec(time) {
      var hour = time.split(':')[0]
      var min = time.split(':')[1]
      var sec = time.split(':')[2]
      var s = Number(hour * 3600) + Number(min * 60) + Number(sec)
      return s
    },
    handleOpen() {},
    handleClose() {},
    open() {
      const h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: h('p', null, [
          h('p', null, '检测到您已使用其他账号登录，该窗口用户已被替换！'),
          h('p', null, '请确认当前账号是否正确'),
          // h('i', { style: 'color: teal' }, 'VNode')
        ]),
        showClose: false,
        confirmButtonText: '确定',
        callback: action => {
          this.$router.push({
            name: 'home'
          })
          // sessionStorage.setItem("$isUserLogin",false)
        }
      });
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/coursePlayByPrivate/coursePlayByPrivate.js